<template>
    <div class="gettingList_market_wrap">
        <el-dialog
        title="选择课程"
        :visible.sync="dialogValue"
        width="800px"
        custom-class="gettingList_dialog"
        @close="handleClose">
        <div slot="title" style="display: flex; align-items: center">
            <span>选择课程</span>
            <p class="common-title">提示：该列表只显示已上架且有章节的课程</p>
        </div>
        <div class="gettinglist_market_table">
            <div class="gettinglist_table_search">
                <div class="gettinglist_table_search_con">
                    <el-input placeholder="请输入课程标题查询" v-model="searchObj.keywords" class="gettinglist_input_tit">
                        <el-button slot="append" type="primary" @click="search">查询</el-button>
                    </el-input>
                </div>
            </div>
           <el-scrollbar class="maket_scrollbar">
                <el-table :data="tableListObj[requestNameObj.data]" @row-click="rowClick" :header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
                    <el-table-column width="55">
                        <!-- <template slot="header">
                            <el-checkbox v-model="checked" :indeterminate="indeterminate" @change="checkAll"></el-checkbox>
                        </template> -->
                        <template slot-scope="scope">
                            <el-checkbox :disabled="disabledList.includes(scope.row.id)" :value="ids.includes(scope.row.id)" @click.native.stop.prevent="rowClick(scope.row)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column property="is_single_name" label="课程类型" width="100">
                    </el-table-column> -->
                    <el-table-column property="img" label="封面" width="200">
                        <template slot-scope="scope">
                            <img :src="scope.row.img" alt="" style="width:67px;height:50px"/>
                        </template>
                    </el-table-column>
                    <el-table-column property="title" label="标题" width="260"></el-table-column>
                    <el-table-column property="price" label="价格"></el-table-column>
                </el-table>
                <Pagination @change="changeSize" :total="tableListObj.total"  v-model="searchObj.page" v-if="Math.ceil(tableListObj.total / searchObj.limit) > 1"></Pagination>
           </el-scrollbar>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancelData">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import Pagination from '@/components/pagination/pagination.vue'
export default {
    props: {
        dialogValue: {
            type: Boolean,
            default: false
        },
        editId: {
            type: [String, Number, Array],
            default: ''
        },
        idsList: {
            type: Array,
            default: () => []
        },
        disabledList: { //禁用列表
            type: Array,
            default: () => []
        },
        requestNameObj: {
            type: Object,
            default: () => {
                return {
                    name: 'methodCourse',
                    data: 'data',
                    total: 'total'
                }
            }
        }
    },
    model: {
        prop: 'dialogValue',
        event: 'change'
    },
    components: {
        Pagination
    },
    data() {
        return {
            dialogVisible: false,
            checked: false,
            indeterminate: false,
            tableListObj: {
                data: [],
                total: 0
            },
            // idsList: [],
            searchObj: {
                method_id:'',
                keywords: '',
                page: 1,
                limit: 10
            },
            headerList: [
                {
                    prop: 'img',
                    label: '封面',
                    width: 200
                },
                {
                    prop: 'title',
                    label: '标题'
                }
            ],
            ids: [],
            classList:[]
        }
    },
    created() {
       this.groupCourseListFun()
    },
    methods: {
        ...mapActions('cusomer', ['methodCourse']),
        ...mapActions('market', ['productSelect']),
        rowClick(row) {
            if(this.disabledList.includes(row.id)){
                return
            }
            console.log(row, 'ppppp')
            if(!this.ids.includes(row.id)) {
                this.ids.push(row.id)
                this.classList.push(row);
            } else {
                let index = this.ids.findIndex(item => item == row.id)
                this.ids.splice(index, 1)
                this.classList.splice(index,1)
            }
        },
        handleClose() {
            this.$emit('change', false)
        },
        sure() {
            this.$emit('change', false)
            this.$emit('sure', this.ids)
            this.$emit('getClassList', this.classList) //输出选择的课程列表
            this.ids = []
        },
        changeSize(size) {
            this.searchObj.page = size
            this.groupCourseListFun()
        },
        async groupCourseListFun(flag) {
            this.searchObj.method_id = this.editId
            if(flag) {
                this.searchObj.page = 1
            }
            let res = await this[this.requestNameObj.name](this.searchObj)
            this.tableListObj = this.requestNameObj.name === 'methodCourse'?  res : {
                ...res,
                total: res.page_info.total_count
            }
            // if(this.type === 'edit') {
            //     this.tableList.forEach(item => {
            //          this.$set(item, 'checked', false)
            //         if(this.ids.includes(item.id)) {
            //             this.$set(item, 'checked', true)
            //         }
            //     })
            //     // this.changeSingle()
            // }
        },
        search() {
            this.groupCourseListFun(true)
        },
        cancelData() {
            this.ids = []
            this.$emit('change', false)
        }
    },
    watch: {
        dialogValue(news) {
            if(news) {
                this.ids = JSON.parse(JSON.stringify(this.idsList))
                this.groupCourseListFun(true)
            }
        },
        idsList:{
            deep:true,
            immediate:true,
            handler(res){
                 this.ids = res;
            }
        }
    }
}
</script>
<style lang="less">
    .gettingList_dialog {
        .el-dialog__body {
            padding: 12px 20px;
        }
    }
    .gettinglist_market_table {
        height: 600px;
        display: flex;
        flex-direction: column;
        .maket_scrollbar {
            flex: 1 0 auto;
            height: 0;
        }
        .pagination_wrap {
            padding: 12px 0 0 0;
        }
        .gettinglist_table_search {
            margin-bottom: 12px;
            display: flex;
            flex-wrap: wrap;
            flex-shrink: 0;
            .gettinglist_table_search_con {
                flex-shrink: 0;
            }
            .gettinglist_input_tit {
                .el-input-group__append, .el-input-group__prepend {
                    background-color: #409eff;
                    border-color: #409eff;
                    color: #fff;
                }
            }
        }
    }
</style>